import { navigateTo } from 'utils/navigation'
import { URL_CONST } from 'utils/urlConsts'

/**
 * Shared navigation target for the PLG credit CTAs (SOC Agent exhaustion
 * screen, credit-request toast, bell notification). Lands on the Credit
 * Management → Billing tab, where credits are actually purchased (IC-49433).
 * Falls back to a hard navigation when no router `history` is available (e.g. a
 * CTA rendered outside Router context) instead of silently no-oping.
 */
export const goToCreditsBilling = (history) => {
  if (history?.push) {
    history.push(URL_CONST.settings.creditsBilling)
    return
  }
  if (typeof window !== 'undefined' && window.location) {
    navigateTo(URL_CONST.settings.creditsBilling)
  }
}
